import {
  CLOSE_MODAL,
  OPEN_MODAL,
} from './actionTypes';

const initialState = {
  modalType: '',
};

export default function globalModal(state = initialState, action) {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        modalType: action.payload,
      };

    case CLOSE_MODAL:
      return {
        ...state,
        modalType: '',
      };

    default:
      return state;
  }
}
